module.exports = __webpack_public_path__ + "static/media/coffee.78188885.jpg";